import React, { useEffect, useState } from 'react';
import { useAppConfigContext } from '../../hooks/useAppConfigContext';
import styles from './SpecialOffers.module.scss';
import { createUrl, getLang } from '../../utils/appConfig';
import eboHeader from '../../images/special-offers/ebo/ebo-header.svg';

export const SpecialOffers = (): JSX.Element | null => {
  const [offerDescription, setOfferDescription] = useState('FREE DINING & DRINKS');
  const [offerDescriptionDetails, setOfferDescriptionDetails] = useState('10% Off Walt Disney World Resort Hotel & Ticket Packages with code ');
  const [offerCode, setOfferCode] = useState('WDW10');

  // Get the app config state.
  const {
    appConfig
  } = useAppConfigContext();

  // Set text language
  useEffect(() => {
    // if (appConfig.current_language === 'de-de') {
    //   setOfferDescription('5% Rabatt auf Orlando Tickets mit Code:');
    // } else if (appConfig.current_language === 'en' || appConfig.current_language === 'en-ie') {
    //   setOfferDescription('15% OFF Orlando Tickets with code');
    // } else {
    //   setOfferDescription('5% OFF Orlando Tickets with code');
    // }
  }, [appConfig.current_language]);

  return (
      <>
        <div className={`${styles.specialOffersContainer} specialOffersContainer ` +
        (appConfig.current_language === 'en' ? 'styles.specialOffersContainerEn' : '') + ' ' +
        (appConfig.current_language === 'de-de' ? 'styles.specialOffersContainerDe' : '')}>
          <a href={createUrl('node/277073')} className={styles.specialOffersLink} >
            <div className={styles.specialOffers}>
              <div className={styles.offerDescriptionContainer}>
                <div className={styles.offerDescription}>
                  {/* {offerDescription} */}
                  <img src={eboHeader} alt="Free dining & drinks" />
                  <span className={styles.offerDescriptionDetails}>
                    {offerDescriptionDetails}
                    <span className={styles.offerCode}>{offerCode}</span>
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>
      </>
  );
};

export default SpecialOffers;
